"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSocketStatusConfig = void 0;
const theme_1 = require("../theme/theme");
const getSocketStatusConfig = (isConnected, isConnecting, retryCount = 0) => {
    if (isConnected) {
        return {
            color: theme_1.HHNTheme.connection.connected,
            text: "Connected",
            isConnected: true,
            isConnecting: false,
        };
    }
    if (isConnecting) {
        const retryText = retryCount > 0 ? `Retrying (${retryCount})...` : "Connecting...";
        return {
            color: theme_1.HHNTheme.connection.connecting,
            text: retryText,
            isConnected: false,
            isConnecting: true,
        };
    }
    return {
        color: theme_1.HHNTheme.connection.disconnected,
        text: "Disconnected",
        isConnected: false,
        isConnecting: false,
    };
};
exports.getSocketStatusConfig = getSocketStatusConfig;
